'use client';

import { useEffect } from 'react';

/**
 * Offers the booking tools to an agent running in the visitor's browser.
 *
 * Renders nothing, and loads nothing for the visitors who are not running such
 * an agent: the implementation is imported only after the browser is seen to
 * support WebMCP at all, so this costs a normal page load one `in` check.
 */
export default function BookingAgentTools() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_FLAG_WEBMCP !== 'true') return;
    if (typeof navigator === 'undefined' || !('modelContext' in navigator)) return;

    let cancelled = false;
    let teardown: (() => void) | null = null;

    import('@/lib/webmcp/bookingTools')
      .then(({ registerBookingTools }) => {
        if (cancelled) return;
        teardown = registerBookingTools();
      })
      .catch((cause) => {
        console.error('[webmcp] booking tools failed to register', cause);
      });

    return () => {
      cancelled = true;
      teardown?.();
    };
  }, []);

  return null;
}
